import EDDivider from '../../../../BaseComponents/Divider/EDDivider';
import React, { useContext, useEffect, useState } from 'react';
import EDMiniDrawer from '../../../../BaseComponents/Drawers/MiniDrawer/EDMiniDrawer';
import { ISortInfo } from '../../../../BaseComponents/Table/Components/SortableTableUtils';
import { NodeUrvalQuery_node_TEDSelection_order } from '../../../../Components/Urval/Components/SavedUrval/Queries/NodeUrvalQuery/_QueryTypes/NodeUrvalQuery';
import { IClientBusinessModel } from '../../../../Types/ClientModelTypes';
import { IColumnDef } from '../../../../Types/ColumnDefType';
import { IUIUrval } from '../../../../Types/UrvalTypes';
import { IFunctionMenuItem } from '../../../../Utils/ObjektVyUtils';
import { ActiveRoutineContext } from '../../../Routing/ActiveRoutine/ActiveRoutineContext';
import BusinessCollectionMenu from '../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/BusinessCollectionMenu';
import { ICollectionDataType } from '../../_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { RutinSettingsContext } from '../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import {
  findRoutineCustomBottomToolbar,
  findRoutineCustomTopToolbar,
} from '../../_Common/Const/Rutiner';
import { SelectNewDetailType } from '../StandardRutin';

interface IProps {
  collection: IClientBusinessModel;
  columns: readonly IColumnDef[];
  setColumns: React.Dispatch<React.SetStateAction<readonly IColumnDef[]>>;
  urval: IUIUrval | null;
  setUrval: React.Dispatch<React.SetStateAction<IUIUrval | null>>;
  refetch: () => void;
  setNewObject: SelectNewDetailType;
  sortedData: ISortInfo<ICollectionDataType>;
  updateSortOrder: (info: ISortInfo<ICollectionDataType>) => void;
  baseCollection: IClientBusinessModel;
  rutinId: number | undefined;
  customBusinessCollectionMenuItems: IFunctionMenuItem[] | undefined;
  datasetLength: number;
  searchText: string;
  rows: ICollectionDataType[];
  setSortInfoFromSelectionOrder: (
    selectionOrder: NodeUrvalQuery_node_TEDSelection_order[]
  ) => void;
}

export const StandardRutinCollectionMenuDrawer: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const activeRoutineContext = useContext(ActiveRoutineContext);
  const rutinAvailabilityContext = useContext(RutinSettingsContext);

  useEffect(() => {
    setOpen(
      rutinAvailabilityContext?.activeRoutine?.routine?.rutinID === 16001
    );
  }, [rutinAvailabilityContext?.activeRoutine?.routine?.rutinID]);

  const [open, setOpen] = useState(
    rutinAvailabilityContext?.activeRoutine?.routine?.rutinID === 16001
  );

  const CustomBottomToolbar = findRoutineCustomBottomToolbar(
    rutinAvailabilityContext.activeRoutine?.routine.rutinKod
  );
  const CustomTopToolbar = findRoutineCustomTopToolbar(
    rutinAvailabilityContext.activeRoutine?.routine.rutinKod
  );

  return (
    <EDMiniDrawer
      open={open}
      close={() => {
        setOpen(false);
      }}
    >
      {CustomTopToolbar && (
        <CustomTopToolbar
          open={open}
          onCloseButtonClick={() => {
            setOpen(false);
          }}
          onOpenButtonClick={() => {
            setOpen(true);
          }}
          sideMenuOpen={open}
        />
      )}
      <EDDivider marginLeft={2} marginRight={open ? 3 : 30} />
      <BusinessCollectionMenu
        collection={props.collection}
        columns={props.columns}
        setColumns={props.setColumns}
        urval={props.urval}
        setUrval={props.setUrval}
        refetch={props.refetch}
        setNewObject={props.setNewObject}
        sortedData={props.sortedData}
        updateSortOrder={props.updateSortOrder}
        baseCollection={props.collection}
        baseId={null}
        errorDisable={rutinAvailabilityContext.hasRutinStartError}
        rutinId={activeRoutineContext?.rutinInfo.rutinID}
        customBusinessCollectionMenuItems={
          props.customBusinessCollectionMenuItems
        }
        datasetLength={props.datasetLength}
        searchText={props.searchText}
        rows={props.rows}
        setSortInfoFromSelectionOrder={props.setSortInfoFromSelectionOrder}
        expanded={open}
      />
      {CustomBottomToolbar && <CustomBottomToolbar sideMenuOpen={open} />}
    </EDMiniDrawer>
  );
};
